import { useNavigate, generatePath } from 'react-router'
import AppBar from '../../components/AppBar'
import routes from '../routes'
import Wrapper from '../../components/Wrapper'
import db from '../../db'
import { useForm } from 'react-hook-form'
import { Box, Button, TextField, Typography } from '@mui/material'
import formErrorMessages from '../../utils/formErrorMessages'
import { ideasState, sessionState } from '../../state'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { serverTimestamp } from 'firebase/firestore'

const NewIdea = () => {
  const { user } = useRecoilValue(sessionState)
  const setIdeas = useSetRecoilState(ideasState)
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<{
    name: string
  }>()

  return (
    <>
      <AppBar backTo={routes.ideas} />
      <Wrapper>
        <form
          onSubmit={handleSubmit(({ name }) => {
            if (user) {
              db.addItem('ideas', {
                name,
                createdBy: user.uid,
                lastUpdatedAt: serverTimestamp()
              })
                .then(result => db.getById('ideas', result.id))
                .then(newIdea => {
                  if (newIdea) {
                    setIdeas(ideas => ({
                      ...ideas,
                      data: [...(ideas.data || []), newIdea]
                    }))
                    navigate(generatePath(routes.idea, { ideaId: newIdea.id }))
                  }
                })
            }
          })}
        >
          <Typography
            variant='h5'
            gutterBottom
            component='label'
            htmlFor='name'
          >
            Name your Idea
          </Typography>
          <TextField
            {...register('name', { required: formErrorMessages.required })}
            id='name'
            name='name'
            variant='filled'
            fullWidth
            error={!!errors.name?.message}
            helperText={errors.name?.message || ' '}
            autoFocus
            margin='normal'
          />
          <Box textAlign='right'>
            <Box display='inline' mr={2}>
              <Button
                color='primary'
                size='large'
                onClick={() => navigate(routes.ideas)}
              >
                Cancel
              </Button>
            </Box>
            <Button
              type='submit'
              color='primary'
              variant='contained'
              size='large'
            >
              create idea
            </Button>
          </Box>
        </form>
      </Wrapper>
    </>
  )
}

export default NewIdea
